import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getBrandDefaults, isExternalUser, isProgrammeUser } from '@pos-app/core-ui';
import { BrandDefaults } from '@pos-app/data';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { customersQuery } from '../../../customers/+state/customers.selectors';
import { ordersQuery } from '../../../orders/+state/orders.selectors';
import { CustomersPartialState } from '../../../customers/+state/customers.reducer';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgIf, AsyncPipe, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-gift-card-balance-search',
    templateUrl: './gift-card-balance-search.component.html',
    styleUrls: ['./gift-card-balance-search.component.scss'],
    imports: [CoreUiModule, NgIf, FormsModule, AsyncPipe, DecimalPipe]
})
export class CustomerGiftCardBalanceSearchComponent implements OnInit, OnDestroy {

  public brandDefaults$: Observable<BrandDefaults>;
  public loadingCustomerDetails$ = this.customerStore.select(customersQuery.getLoadingCustomerDetails);
  public loadingFetchingOrderFromJDE$ = this.customerStore.select(ordersQuery.getIsFetchingJdeOrder);
  public isShowUser: boolean;

  private isFetchingSubject = new BehaviorSubject<boolean>(false);
  public isFetching$ = this.isFetchingSubject.asObservable();
  public giftCardNumber: string;
  public giftCardBalance: string;
  public giftCardErrorMessage: string;

  private unSubscribe$ = new Subject<void>();

  constructor(
    private customerStore: Store<CustomersPartialState>,

    private coreUiStore: Store<CoreUiPartialState>,
    private apiService: ApiService,
    private toastr: ToastrService
  ) {}

  public ngOnInit(): void {
    this.brandDefaults$ = this.coreUiStore.select(getBrandDefaults);

  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  public fetchCardBalance(): void {
    this.giftCardErrorMessage = null;
    this.giftCardBalance = undefined;

    if (!this.giftCardNumber) {
      return;
    }

    this.isFetchingSubject.next(true);
    this.apiService
      .fetchCardBalance({
        cardID: this.giftCardNumber,
      })
      .pipe(
        finalize(() => this.isFetchingSubject.next(false)),
        takeUntil(this.unSubscribe$)
      )
      .subscribe(
        (res) => {
          if (res) {
            this.giftCardBalance = res.balance;
          }
        },
        (error) => {
          this.giftCardErrorMessage = error.ErrorMessage;
          this.toastr.error(error.ErrorMessage);
        }
      );
  }
}
